import React from "react";
import { ContentPolicyModalTemplate } from "themes/application/common/components";

function ContentPolicyModal(props) {
    return <ContentPolicyModalTemplate {...props} />;
}

export default ContentPolicyModal;
